import { VStack } from "@chakra-ui/react";

export default function FormContainer({ children, ...props }) {
  return (
    <VStack spacing={4} align="stretch" {...props}>
      {children}
    </VStack>
  );
}
